
import React from "react";
import "../../../assests/css/teachers/TeacherLogout.css";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const TeacherLogout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    console.log("Teacher logout function called");

    // Remove teacher login information
    localStorage.removeItem("teacherEmail");
    localStorage.removeItem("teacherPassword");
    localStorage.removeItem("teacher");
    localStorage.removeItem("loggedInTeacher");
    localStorage.removeItem("authToken");

    // Show success message
    Swal.fire({
      icon: "success",
      title: "Logged Out!",
      text: "Your logout was successful",
      confirmButtonColor: "#6A88CE",
    }).then(() => {
      // Go to teacher login after alert
      navigate("/teacher-login");
    });
  };

  const handleCancel = () => {
    navigate("/teacher/dashboard");
  };

  return (
    <div className="tp-logout-page">

      <div className="tp-logout-card">

        <FaSignOutAlt className="tp-logout-icon" />

        <h1 className="tp-logout-title">
          Logout
        </h1>

        <p className="tp-logout-text">
          Are you sure you want to logout? Your progress is saved.
        </p>

        <div className="tp-logout-btns">

          <button
            className="tp-logout-confirm"
            onClick={handleLogout}
          >
            Yes, Logout
          </button>

          <button
            className="tp-logout-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>

        </div>

        <p className="tp-logout-note">
          👋 See you soon!
        </p>

      </div>

    </div>
  );
};

export default TeacherLogout;
